import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  name: 'Home',
  path: '/'
}, {
  name: 'Weddings',
  path: '/weddings'
}, {
  name: 'Birthdays',
  path: '/birthdays'
}, {
  name: 'Special Events',
  path: '/special-events'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-94">
        <div className="container mx-auto px-4 flex gap-[25px] flex-row items-start justify-start" data-id="element-95">
          <Link to="/" className="text-2xl font-bold text-stone-900 font-[Merriweather,_serif]" data-id="element-96">
            Mangalita <span className="text-rose-500" data-id="element-97">Events</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-8 font-medium" data-id="element-98">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`transition-colors ${location.pathname === link.path ? 'text-rose-500' : 'text-stone-600 hover:text-rose-500'}`} data-id="element-99">
                {link.name}
              </Link>)}
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-stone-700" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-100">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-101" /> : <MenuIcon className="w-6 h-6" data-id="element-102" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Drawer */}
      <AnimatePresence data-id="element-103">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 md:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-104" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed top-0 right-0 bottom-0 w-72 bg-white shadow-2xl z-50 md:hidden" data-id="element-105">
              <div className="p-6 pt-20" data-id="element-106">
                <nav className="flex flex-col gap-4" data-id="element-107">
                  {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-lg font-medium py-2 px-4 rounded-lg transition-colors ${location.pathname === link.path ? 'bg-rose-50 text-rose-500' : 'text-stone-700 hover:bg-stone-50'}`} data-id="element-108">
                      {link.name}
                    </Link>)}
                </nav>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}